<template>
  <q-dialog
    @update:model-value="this.onUpdate"
    :persistent="!!this.modalData?.data?.persistent"
    v-model="show"
    @escape-key="() => closePopup(this.modalData.type)"
    :allow-focus-outside="false"
    class="modal__dialog"
  >
    <q-card
      :class="['modal__wrapper scrollbar__wrapper', { modal__wrapper_borderless: !!this.modalData?.data?.borderless }]"
      ref="componentRef"
    >
      <q-card-section
        class="row items-center q-pb-none justify-between modal__header"
      >
        <div class="text-h6 modal__title">
          {{ modalData.data?.title || "" }}
        </div>
        <q-space />
        <q-btn
          :class="['close-btn', { 'text-red': !!modalData.data?.borderless }]"
          @click="() => closePopup(this.modalData.type)"
          flat
          dense
          v-close-popup
        >
          <img src="/img/icons/close.svg" style="width: 13px;" alt="close" />
        </q-btn>
      </q-card-section>
      <component
        :is="modalData.type"
        :data="modalData.data"
        :closeModal="closePopup"
      />
    </q-card>
  </q-dialog>
</template>
<script>
import { defineAsyncComponent } from "vue";
import { appActions } from "@/services/store/modules/app_module/app_actions.js";
import ConfirmModal from "@/components/modal/modals/modal-types/ConfirmModal.vue";
import AddFinancePayment from "@/components/modal/modals/AddFinancePayment";
import CreateAdditionalAgreement from "@/components/modal/modals/create-additional-agreement";
import ChangePaymentStatus from "@/components/modal/modals/ChangePaymentStatus";
import ChangeMaterialStatus from "@/components/modal/modals/ChangeMaterialStatus";
import RemontTimelineStep from "@/components/modal/modals/remont-timeline-step";
import GradeTimelineStep from "@/components/modal/modals/grade-timeline-step";
import ChangeFinancePayment from "@/components/modal/modals/change-finance-payment";
import ModalText from "@/components/modal/modals/modal-text";
import FinancePaymentDocs from "@/components/modal/modals/finance-payment-docs";
import ReceiveKeysEdit from "@/components/modal/modals/receive-keys-edit";
import RemontProjectEdit from "@/components/modal/modals/remont-project-edit";
import CheckListPhotos from "@/components/modal/modals/check-list-photos";
import ParticipantsReplacementHistory from "@/components/modal/modals/participants-replacement-history";
import ChangeRemontResponsible from "@/components/modal/modals/change-remont-responsible";
import AddTranche from "@/components/modal/modals/add-tranche";
import AddIncome from "@/components/modal/modals/add-income";
import AddCost from "@/components/modal/modals/add-cost";
import AddStage from "@/components/modal/modals/add-stage";
import AddRemontService from "@/components/modal/modals/add-remont-service";
import AddDoc from "@/components/modal/modals/add-doc";
import ProjectReview from "@/components/modal/modals/project-review";
import AddRoom from "@/components/modal/modals/add-room";
import AddNoticeTemplate from "@/components/modal/modals/add-notice-template";
import AddHandbookProvider from "@/components/modal/modals/add-handbook-provider";
import AddHandbookContractor from "@/components/modal/modals/add-handbook-contractor"
import AddHandbookTechprojectDeveloper from "@/components/modal/modals/add-handbook-techproject-developer"
import AddHandbookCleaning from "@/components/modal/modals/add-handbook-cleaning"
import EditChatMessage from "@/components/modal/modals/edit-chat-message";
import ProviderRequestServiceComment from "@/components/modal/modals/provider-request-service-comment";
import ProviderRequestsItemPaint from "@/components/modal/modals/provider-requests-item-paint";
import EditHandbookWorkset from "@/components/modal/modals/edit-handbook-workset";
import EditHandbookWorksetSpeciality from "@/components/modal/modals/edit-handbook-workset-speciality";
import AddProvidersAgreement from "@/components/modal/modals/add-providers-agreement";
import AddHandbookDocument from "@/components/modal/modals/add-handbook-document";
import AddAgreement from "@/components/modal/modals/add-agreement";
import AddGradeAction from "@/components/modal/modals/add-grade-action";
import AddStepCondition from "@/components/modal/modals/add-step-condition";
import AddStepIncludeCond from "@/components/modal/modals/add-step-include-cond";
import AddTimelineStep from "@/components/modal/modals/add-timeline-step";
import AddGradeTimelineStep from "@/components/modal/modals/add-grade-timeline-step";
import AddStepActivity from "@/components/modal/modals/add-step-activity";
import ChatGallery from "@/components/modal/modals/chat-gallery";
import AddMobileAppVersion from "@/components/modal/modals/add-mobile-app-version";
import UpdateBalances from "@/components/modal/modals/update-balances";
import ExecutiveReportComments from "@/components/modal/modals/executive-report-comments";
import ExecutiveReportDeadlineView from "@/components/modal/modals/executive-report-deadline-view";
import ExecutiveReportSetDeadline from "@/components/modal/modals/executive-report-set-deadline";
import ExecutiveReportEmployeeSet from "@/components/modal/modals/executive-report-employee-set";
import ExecutiveReportBulkAssignDesigner from "@/components/modal/modals/executive-report-bulk-assign-designer";
import ExecutiveReportNps from "@/components/modal/modals/executive-report-nps";
import ExecutiveReportAnalyze from "@/components/modal/modals/executive-report-analyze";
import ExecutiveReportWarrantyAccept from "@/components/modal/modals/executive-report-warranty-accept";
import ExecutiveReportFlatList from "@/components/modal/modals/executive-report-flat-list";
import ExecutiveReportOkk from "@/components/modal/modals/executive-report-okk";
import ChangeRemontGrade from "@/components/modal/modals/change-remont-grade";
import NestedGradeTimelineSteps from "@/components/modal/modals/nested-grade-timeline-steps";
import ApartmentOwnersHistory from "@/components/modal/modals/apartment-owners-history";
import ChangeWarrantyStatus from "@/components/modal/modals/change-warranty-status";
import ChangeWarrantyEmployee from "@/components/modal/modals/change-warranty-employee";
import WarrantyAct from "@/components/modal/modals/warranty-act";
import ChangeWarrantyRequest from "@/components/modal/modals/change-warranty-request";
import ChangeDSSum from "@/components/modal/modals/change-ds-sum";
import AddWorksetPrice from "@/components/modal/modals/add-workset-price";
import AddHiddenWorkset from "@/components/modal/modals/add-hidden-workset";
import AddHandbookContractorWorkset from "@/components/modal/modals/add-handbook-contractor-workset";
import TextConstructorWorks from "@/components/modal/modals/text-constructor-works";
import TextConstructorMaterials from "@/components/modal/modals/text-constructor-materials";
import TextConstructorInfo from "@/components/modal/modals/text-constructor-info";
import TextConstructorMaterialPriceChange from "@/components/modal/modals/text-constructor-material-price-change";
import ProviderRequestsContractorForm from "@/components/modal/modals/provider-requests-contractor-form";
import ProviderRequestsProviderForm from "@/components/modal/modals/provider-requests-provider-form";
import ProviderRequestsShippingDateHistory from "@/components/modal/modals/provider-requests-shipping-date-history";
import ProviderRequestsShippingDateChange from "@/components/modal/modals/provider-requests-shipping-date-change";
import ProviderRequestsQtyDeliveryChange from "@/components/modal/modals/provider-requests-qty-delivery-chng";
import ProviderRequestsInvoiceItem from "@/components/modal/modals/provider-requests-invoice-item";
import ProviderRequestsGenerateInvoice from "@/components/modal/modals/provider-requests-generate-invoice";
import ProviderRequestsMultipleStatus from "@/components/modal/modals/provider-requests-multiple-status";
import ProviderRequestsMultipleInvoice from "@/components/modal/modals/provider-requests-multiple-invoice";
import ProviderRequestsChangeWarehouse from "@/components/modal/modals/prov-req-change-warehouse";
import ProviderRequestsShipFromWarehouse from "@/components/modal/modals/prov-req-ship-from-warehouse";
import ProviderRequestsInvoiceList from "@/components/modal/modals/prov-req-invoice-list";
import ProviderRequestsStatusHistory from "@/components/modal/modals/prov-req-status-history";
import ProviderRequestsRefundInvoices from "@/components/modal/modals/prov-req-refund-invoices";
import ProviderRequestsRefundRelease from "@/components/modal/modals/prov-req-refund-release";
import ProviderRequestsMaterialSelect from "@/components/modal/modals/provider-requests-material-select";
import ProviderRequestAdditionReject from "@/components/modal/modals/provider-request-addition-reject";
import MaterialListSetRequirement from "@/components/modal/modals/material-list-set-requirement";
import MaterialListAttachAgreement from "@/components/modal/modals/material-list-attach-agreement";
import MaterialListAddPrice from "@/components/modal/modals/material-list-add-price";
import MaterialsConstructorUpdImages from "@/components/modal/modals/materials-constructor-upd-images";
import MaterialsConstructorUpdKitchenDesc from "@/components/modal/modals/materials-constructor-upd-kitchen-desc";
import MaterialsConstructorUpdAdditionalImgs from "@/components/modal/modals/materials-constructor-upd-additional-imgs";
import MaterialsConstructorUpdProp from "@/components/modal/modals/materials-constructor-upd-prop";
import MaterialsInfo from "@/components/modal/modals/materials-info";
import MaterialGroupMeasure from "@/components/modal/modals/material-group-measure";
import AddPromoMaterial from "@/components/modal/modals/add-promo-material";
import FloorSchemaObjectInfo from "@/components/modal/modals/floor-schema-object-info";
import ResidentialGrouping from "@/components/modal/modals/residential-grouping";
import AddContractorWorksPhoto from "@/components/modal/modals/add-contractor-works-photo";
import AddContractorReview from "@/components/modal/modals/add-contractor-review";
import AddFloorMap from "@/components/modal/modals/add-floor-map";
import AddShowroomPhoto from "@/components/modal/modals/add-showroom-photo";
import FlatCommonAreaUpd from "@/components/modal/modals/flat-common-area-upd";
import FlatClone from "@/components/modal/modals/flat-clone";
import FloorMapErrors from "@/components/modal/modals/floor-map-errors";
import FrameTypeParams from "@/components/modal/modals/frame-type-params";
import UpdFrameTypeParam from "@/components/modal/modals/frame-type-params/UpdParam";
import FrameUpd from "@/components/modal/modals/frame-upd";
import UpdShellProjects from "@/components/modal/modals/upd-shl-projects";
import UpdShellProjectPerfomancer from "@/components/modal/modals/upd-shl-project-perfomancer";
import AddWorkSetCheckGroups from "@/components/modal/modals/add-work-set-check-groups";
import AddWorkSetCheckGroupsLink from "@/components/modal/modals/add-work-set-check-groups-link";
import CopyPasteEntranceProperties from "@/components/modal/modals/copy-paste-entrance-properties"
import ChangeProjectMaterials from "@/components/modal/modals/change-project-materials"
import AddAvr from "@/components/modal/modals/add-avr"

// Окно нужно одной странице — файл грузится при первом открытии, не в общем app.js
const InstallmentRefund = defineAsyncComponent(() => import("@/components/modal/modals/installment-refund"));

export default {
  name: "modal-dialog",
  // таблицы внутри модалок не переходят в страничный режим (см. CustomTable, pageMode)
  provide: {msInModal: true},
  components: {
    GradeTimelineStep,
    ConfirmModal,
    CreateAdditionalAgreement,
    ChangeWarrantyStatus,
    EditChatMessage,
    ProviderRequestServiceComment,
    ProviderRequestsItemPaint,
    EditHandbookWorkset,
    EditHandbookWorksetSpeciality,
    CheckListPhotos,
    ParticipantsReplacementHistory,
    ModalText,
    FinancePaymentDocs,
    ReceiveKeysEdit,
    RemontProjectEdit,
    RemontTimelineStep,
    ChangeRemontResponsible,
    ChangeMaterialStatus,
    ChangeFinancePayment,
    ChangePaymentStatus,
    AddFinancePayment,
    AddTranche,
    ApartmentOwnersHistory,
    AddCost,
    AddStage,
    AddRemontService,
    AddDoc,
    ProjectReview,
    AddRoom,
    AddWorksetPrice,
    AddHiddenWorkset,
    AddHandbookContractorWorkset,
    AddStepCondition,
    AddStepIncludeCond,
    AddGradeAction,
    AddStepActivity,
    AddIncome,
    AddNoticeTemplate,
    AddHandbookProvider,
    AddHandbookContractor,
    InstallmentRefund,
    AddHandbookTechprojectDeveloper,
    AddHandbookCleaning,
    AddProvidersAgreement,
    AddHandbookDocument,
    AddAgreement,
    UpdateBalances,
    ChatGallery,
    AddMobileAppVersion,
    ExecutiveReportComments,
    ExecutiveReportDeadlineView,
    ExecutiveReportSetDeadline,
    ExecutiveReportEmployeeSet,
    ExecutiveReportBulkAssignDesigner,
    ExecutiveReportNps,
    ExecutiveReportAnalyze,
    ExecutiveReportWarrantyAccept,
    ExecutiveReportFlatList,
    ExecutiveReportOkk,
    ChangeRemontGrade,
    AddTimelineStep,
    AddGradeTimelineStep,
    NestedGradeTimelineSteps,
    ChangeWarrantyEmployee,
    WarrantyAct,
    ChangeWarrantyRequest,
    ChangeDSSum,
    TextConstructorWorks,
    TextConstructorMaterials,
    TextConstructorInfo,
    TextConstructorMaterialPriceChange,
    ProviderRequestsContractorForm,
    ProviderRequestsProviderForm,
    ProviderRequestsShippingDateHistory,
    ProviderRequestsShippingDateChange,
    ProviderRequestsQtyDeliveryChange,
    ProviderRequestsInvoiceItem,
    ProviderRequestsGenerateInvoice,
    ProviderRequestsMultipleStatus,
    ProviderRequestsMultipleInvoice,
    ProviderRequestsChangeWarehouse,
    ProviderRequestsShipFromWarehouse,
    ProviderRequestsInvoiceList,
    ProviderRequestsStatusHistory,
    ProviderRequestsRefundInvoices,
    ProviderRequestsRefundRelease,
    ProviderRequestsMaterialSelect,
    ProviderRequestAdditionReject,
    MaterialListSetRequirement,
    MaterialListAttachAgreement,
    MaterialListAddPrice,
    MaterialsConstructorUpdImages,
    MaterialsConstructorUpdKitchenDesc,
    MaterialsConstructorUpdAdditionalImgs,
    MaterialsConstructorUpdProp,
    MaterialsInfo,
    MaterialGroupMeasure,
    AddPromoMaterial,
    FloorSchemaObjectInfo,
    ResidentialGrouping,
    AddContractorWorksPhoto,
    AddContractorReview,
    AddFloorMap,
    AddShowroomPhoto,
    FlatCommonAreaUpd,
    FlatClone,
    FloorMapErrors,
    FrameTypeParams,
    FrameUpd,
    UpdFrameTypeParam,
    UpdShellProjects,
    UpdShellProjectPerfomancer,
    AddWorkSetCheckGroups,
    AddWorkSetCheckGroupsLink,
    CopyPasteEntranceProperties,
    ChangeProjectMaterials,

    AddAvr
  },
  computed: {
    show() {
      return this.$store.state.app.modal.show;
    },
    modalData() {
      return this.$store.state.app.modal;
    },
  },
  methods: {
    closePopup(type) {
      if (this.modalData?.data?.preventClose) return
      const currentType = this.modalData.type
      const onClose = this.modalData?.data?.onClose
      if (type === currentType || type === undefined) {
        this.$store.commit(appActions.closeModal());
      }
      if (onClose) onClose()
    },
    onUpdate(val) {
      if (val === false && this.modalData?.data?.close !== false)
        this.closePopup(this.modalData.type);
    },
  }
};
</script>

<style lang="scss">
// Общий вид всех модалок (MODAL_NAMES): скругление, отступы, заголовок; футер с кнопками
// прилипает к низу окна, чтобы в длинных формах не листать до кнопок.
// Прилипает только футер, который стоит в самом конце окна: последний элемент корня модалки
// или последний элемент её последней формы. Футер формы, после которой идёт ещё что-то
// (таблица, второй набор кнопок), остаётся на своём месте — иначе он наезжает на следующий блок.
.q-card.modal__wrapper:not(.modal__wrapper_borderless) {
  > :last-child > .footer:last-child,
  > :last-child > form:last-child > .footer:last-child,
  > form:last-child > .footer:last-child {
    position: sticky;
    bottom: calc(-1 * var(--ms-modal-pad));
    z-index: 2;
    margin-bottom: calc(-1 * var(--ms-modal-pad));
    padding: 12px 0 var(--ms-modal-pad);
    background: var(--ms-surface);
    border-top: 1px solid var(--ms-divider);
  }
}
</style>
<style scoped lang="scss">
.close-btn {
  width: 30px;
  height: 30px;
  min-height: unset;
  padding: 0;
  border-radius: var(--ms-radius-sm);
  color: var(--ms-text-secondary);

  &:hover {
    background: var(--ms-primary-50);
  }
}
.modal {
  &__wrapper {
    --ms-modal-pad: 18px;
    padding: var(--ms-modal-pad) 20px;
    border-radius: 14px !important;
    max-width: initial !important;
    box-shadow: 0 20px 48px rgba(15, 23, 42, 0.18);

    &_borderless {
      background: none;
      box-shadow: none;
      max-height: initial !important;

      .modal__header {
        border-bottom: none;
      }
    }
  }

  &__header {
    gap: 10px;
    flex-wrap: nowrap;
    padding: 0 0 12px;
    margin-bottom: 14px;
    border-bottom: 1px solid var(--ms-divider);
  }

  &__title {
    min-width: 0;
    font-size: 18px;
    line-height: 24px;
    font-weight: 700;
    letter-spacing: 0;
    color: var(--ms-primary-ink);
    overflow-wrap: anywhere; // длинное слово в заголовке не распирает окно на телефоне
  }

  @media (max-width: 576px) {
    &__wrapper {
      --ms-modal-pad: 16px;
      padding: var(--ms-modal-pad);
    }

    &__dialog {
      padding: 12px;
    }
  }

  @media (max-width: 370px) {
    &__wrapper {
      --ms-modal-pad: 12px;
      padding: var(--ms-modal-pad);
    }

    &__dialog {
      padding: 5px;
    }
  }
}
</style>
